import grading from '@/api/grading-definition'
import subProgram from '@/api/sub-program'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  main_programs: [],
  edit_data: {},
  sub_programs: [],
  sub_program_copys: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_MAIN_PROGRAMS (state, data) {
    state.main_programs = data
  },
  SET_EDIT_DATA (state, data) {
    state.edit_data = data
  },
  SET_SUB_PROGRAMS(state, data) {
    state.sub_programs = data
  },
  SET_SUB_PROGRAM_COPYS(state, data) {
    state.sub_program_copys = data
  }
}

export const actions = {
  fetch (context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return grading.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store (context, data) {
    return grading.store(data)
  },
  copy (context, data) {
    return grading.copy(data)
  },

  async find (context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await grading.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  update (context, data) {
    return grading.update(data)
  },

  async dataBeforeCreate (context) {
    if (!context.state.main_programs.length > 0) {
      let response = await grading.mainProgram()
      context.commit('SET_MAIN_PROGRAMS', response)
    }
  },
  async subProgram(context, acp_id) {
    context.commit('SET_SUB_PROGRAMS', [])
    let response = await grading.getSubProgram(acp_id)
    context.commit('SET_SUB_PROGRAMS', response)
  },
  getSubProgram(context, attributes = {}) {
    return subProgram.get({
      params: {
        fields: {
          academic_program_subs: 'acp_id,acps_id,acps_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  async getSubProgramCopy(context, acp_id) {
    context.commit('SET_SUB_PROGRAM_COPYS', [])
    let response = await grading.getSubProgramCopy(acp_id)
    context.commit('SET_SUB_PROGRAM_COPYS', response)
  }
}
